import {
  EuiFlexGroup,
  EuiPanel,
  EuiTitle,
  EuiSpacer,
  EuiStat,
} from "@inscopix/ideas-eui";
import { IconComputeCredits } from "components/IconComputeCredits/IconComputeCredits";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";
import { filesize } from "utils/filesize";
import { roundToSignificant } from "utils/roundToSignificant";

/*
 * Project page sidebar panel with resource consumption information
 */
export const PanelResources = () => {
  const { project } = useProjectDataContext();

  return (
    <EuiPanel
      hasBorder={false}
      hasShadow={false}
      paddingSize="s"
      style={{ flexGrow: "0" }}
    >
      <EuiTitle size="s">
        <span>Resources</span>
      </EuiTitle>
      <EuiSpacer size="s" />
      <EuiStat
        key="active-storage-size"
        titleSize={"xs"}
        title={filesize(project.activeStorageSize)}
        description="Active storage"
        reverse
      />
      <EuiSpacer size="s" />
      <EuiStat
        key="archive-storage-size"
        titleSize={"xs"}
        title={filesize(project.archivedStorageSize)}
        description="Archived storage"
        reverse
      />
      <EuiSpacer size="s" />
      <EuiStat
        key="compute-credits"
        titleSize={"xs"}
        titleElement="div"
        title={
          <EuiFlexGroup alignItems="baseline" gutterSize="s">
            {roundToSignificant(project.usedCredits ?? 0)}{" "}
            <IconComputeCredits />
          </EuiFlexGroup>
        }
        description={"Compute credits"}
        reverse
      />
    </EuiPanel>
  );
};
